import { render, staticRenderFns } from "./BsCheckbox.vue?vue&type=template&id=018236f6&"
import script from "./BsCheckbox.vue?vue&type=script&lang=js&"
export * from "./BsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BsCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports